import React from "react";

import Icon from "src/componets/Icon";

import './style.scss';

interface PropsInterface {
  className?: string;
  collapsible?: boolean;
  children: React.ReactNode;
}

const STORAGE_KEY = 'v-right-sidebar-collapsed';

export const RightSidebar = ({ className, collapsible, children }: PropsInterface) => {
  const [collapsed, setCollapsed] = React.useState<boolean>(
    () => collapsible === true && localStorage.getItem(STORAGE_KEY) === '1'
  );

  const toggle = () => {
    setCollapsed(prev => {
      const next = !prev;
      localStorage.setItem(STORAGE_KEY, next ? '1' : '0');
      return next;
    });
  };

  const classes = [
    'v-right-sidebar',
    collapsible && collapsed ? 'v-right-sidebar--collapsed' : '',
    className || ''
  ].filter(Boolean).join(' ');

  return (
    <div className={classes}>
      {collapsible &&
        <button
          type='button'
          className='v-link2 v-right-sidebar__toggle'
          onClick={toggle}
          title={collapsed ? 'Show panel' : 'Hide panel'}
          aria-label={collapsed ? 'Show panel' : 'Hide panel'}
        >
          <Icon icon={collapsed ? 'fa-solid fa-angle-left' : 'fa-solid fa-angle-right'} />
        </button>
      }

      <div className='v-right-sidebar__content'>
        {children}
      </div>
    </div>
  )
}
